import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import ForceTwoFactorSetup from "@/pages/ForceTwoFactorSetup";
import Index from "@/pages/Index";
import SellerIntake from "@/pages/SellerIntake";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import DealAnalyzer from "@/pages/DealAnalyzer";
import Prospecting from "@/pages/Prospecting";
import Tasks from "@/pages/Tasks";
import Schedule from "@/pages/Schedule";
import Offers from "@/pages/Offers";
import DueDiligence from "@/pages/DueDiligence";
import Documents from "@/pages/Documents";
import Forms from "@/pages/Forms";
import SignPage from "@/pages/SignPage";
import Portfolio from "@/pages/Portfolio";
import Settings from "@/pages/Settings";
import Enquiries from "@/pages/Enquiries";

function Private({ children }) {
  return (
    <ProtectedRoute>
      <PasswordGate>
        <Layout>{children}</Layout>
      </PasswordGate>
    </ProtectedRoute>
  );
}

function PasswordGate({ children }) {
  const { user } = useAuth();
  if (user && user.must_change_password) return <ForcePasswordChange />;
  const needs2fa = user && (["System Owner", "Administrator"].includes(user.role) || user.twofa_required) && !user.two_factor_enabled;
  if (needs2fa) return <ForceTwoFactorSetup />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/seller-intake" element={<SellerIntake />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sign/:token" element={<SignPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/dashboard" element={<Private><Dashboard /></Private>} />
            <Route path="/leads" element={<Private><Leads /></Private>} />
            <Route path="/leads/:id" element={<Private><LeadDetail /></Private>} />
            <Route path="/prospecting" element={<Private><Prospecting /></Private>} />
            <Route path="/deal-analyzer" element={<Private><DealAnalyzer /></Private>} />
            <Route path="/tasks" element={<Private><Tasks /></Private>} />
            <Route path="/schedule" element={<Private><Schedule /></Private>} />
            <Route path="/offers" element={<Private><Offers /></Private>} />
            <Route path="/due-diligence" element={<Private><DueDiligence /></Private>} />
            <Route path="/documents" element={<Private><Documents /></Private>} />
            <Route path="/forms" element={<Private><Forms /></Private>} />
            <Route path="/portfolio" element={<Private><Portfolio /></Private>} />
            <Route path="/enquiries" element={<Private><Enquiries /></Private>} />
            <Route path="/settings" element={<Private><Settings /></Private>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
